const ErpModule = () => import('@pages/erp/ErpModule')
const PositionsIndex = () => import('@pages/erp/positions/PositionsIndex')
const ClientArchivesIndex = () => import('@pages/erp/archives/ArchiveIndex')
const GroupsIndex = () => import('@pages/erp/groups/GroupsIndex')
const ClientResourceIndex = () => import('@pages/erp/resources/ResourceIndex')
const SubresourcesIndex = () => import('@pages/erp/resources/subresources/SubresourcesIndex')
const CapabilitiesAssignmentIndex = () => import('@pages/erp/capabilities/CapabilitiesAssignmentIndex')
const ClientNewsletterIndex = () => import('@pages/erp/newsletters/NewsletterIndex')
const NewsletterCreate = () => import('@pages/erp/newsletters/NewsletterCreate')
const EmployeeClientNewsletters = () => import('@pages/erp/newsletters/NewsletterEmployees')
const ClientFaults = () => import('@pages/erp/faults/Faults')
const FaultForm = () => import('@pages/erp/faults/FaultForm')
const FaultTypeForm = () => import('@pages/erp/faults/FaultTypeForm')
const FaultTypes = () => import('@pages/erp/faults/FaultTypes')
const EmployeeClientFaults = () => import('@pages/erp/faults/FaultEmployees')
const EmployeesPetitionsIndex = () => import('@pages/erp/petitions/PetitionIndex')
const PetitionsIndex = () => import('@pages/erp/petitions/administration/AdministrationPetitionsIndex')
const AgentIndex = () => import('@pages/erp/agents/AgentIndex')
const ChatbotsIndex = () => import('@pages/erp/chatbots/Index')
const GeneralReportsIndex = () => import('@pages/erp/generalReports/Index.vue')

export default {
    path: 'erp',
    component: ErpModule,
    children: [
        {
            path: 'positions',
            component: PositionsIndex,
            name: 'positions',
        },
        {
            path: 'archives',
            component: ClientArchivesIndex,
            name: 'clientArchives',
        },
        {
            path: 'groups',
            component: GroupsIndex,
            name: 'groups',
        },
        {
            path: 'resources',
            component: ClientResourceIndex,
            name: 'clientResources',
        },
        {
            path: 'sub-resources',
            component: SubresourcesIndex,
            name: 'clientSubresources',
        },
        {
            path: 'capabilities-assignment',
            component: CapabilitiesAssignmentIndex,
            name: 'capabilitiesAssignment',
        },
        {
            path: 'newsletters',
            component: ClientNewsletterIndex,
            name: 'clientNewsletters',
        },
        {
            path: 'newsletter-create',
            component: NewsletterCreate,
            name: 'clientNewsletterCreate',
        },
        {
            path: ':currentNewsletterId/newsletter-edit',
            component: NewsletterCreate,
            name: 'clientNewsletterEdit',
        },
        {
            path: 'employee-newsletters',
            component: EmployeeClientNewsletters,
            name: 'employeeClientNewsletters',
        },
        {
            path: 'fault-create',
            component: FaultForm,
            name: 'clientFaultCreate',
        },
        {
            path: 'client-faults',
            component: ClientFaults,
            name: 'clientFaults',
        },
        {
            path: ':currentFaultId/fault-edit',
            component: FaultForm,
            name: 'clientFaultEdit',
        },
        {
            path: 'fault-types',
            component: FaultTypes,
            name: 'clientFaultTypes',
        },
        {
            path: 'fault-type-create',
            component: FaultTypeForm,
            name: 'clientFaultTypeCreate',
        },
        {
            path: ':currentFaultTypeId/fault-type-edit',
            component: FaultTypeForm,
            name: 'clientFaultTypeEdit',
        },
        {
            path: 'employee-faults',
            component: EmployeeClientFaults,
            name: 'employeeClientFaults',
        },
        {
            path: 'employee-petitions',
            component: EmployeesPetitionsIndex,
            name: 'employeePetitions',
        },
        {
            path: 'petitions-management',
            component: PetitionsIndex,
            name: 'clientPetitions',
        },
        {
            path: 'agents',
            component: AgentIndex,
            name: 'agentsIndex',
        },
        {
            path: 'chatbots',
            component: ChatbotsIndex,
            name: 'chatbotsIndex',
        },
        {
            path: 'general-reports',
            component: GeneralReportsIndex,
            name: 'generalReportsErp',
        }
    ],
}
